import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="inline-flex items-center gap-3 bg-carbon-900 border border-electric/30 px-4 py-2 rounded-full font-mono text-sm sm:text-base tracking-tight" aria-live="polite" data-id="element-54">
      <div className="w-2 h-2 rounded-full bg-electric animate-pulse" data-id="element-55" />
      <span className="text-carbon-400 uppercase text-xs sm:text-sm font-semibold tracking-widest" data-id="element-56">
        Precio de lanzamiento expira en:
      </span>
      <span className="text-electric font-bold text-base sm:text-lg" data-id="element-57">
        {minutes.toString().padStart(2, '0')}:
        {seconds.toString().padStart(2, '0')}
      </span>
    </div>;
}